export var TypeActionWaterTower;
(function (TypeActionWaterTower) {
    TypeActionWaterTower["Collect"] = "WaterTower > collect";
    TypeActionWaterTower["Select"] = "WaterTower > select";
})(TypeActionWaterTower || (TypeActionWaterTower = {}));
export var actionWaterTowerCollectWater = function () { return ({
    type: TypeActionWaterTower.Collect,
}); };
export var actionWaterTowerSelect = function () { return ({
    type: TypeActionWaterTower.Select,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/actionWaterTower.ts
// module id = 424
// module chunks = 3